<template>
    <b-modal
        ref="dialog"
        lazy
        title-tag="h2"
        title="Confirmation"
        footer-class="d-flex"
        @show="$emit('loaded')"
    >
        <p v-if="type === 'INVOICE_PAID_EXTEND'">
            Payment for {{ nightLabel(this.actualNights) }} was already
            received. Checking out on {{ actualCheckoutDateStr }} would extend
            the original reservation by {{ nightLabel(extendedNights) }}. This
            invoice will be reopened so that the additional payment can be
            collected. Do you wish to continue?
        </p>
        <p v-else-if="type === 'INVOICE_OVERPAID_UNDERPAID'">
            The change you are requesting would cause the invoice to be
            overpaid. If you continue,&nbsp;
            <span v-if="paymentAmount === 0 && creditAmount > 0">
                the credit that applied to the invoice will be unapplied for
                this client. Do you wish to continue?
            </span>
            <span v-else>
                a credit for the overpayment will automatically be created for
                this client. Do you wish to continue?
            </span>
        </p>
        <template v-slot:modal-footer>
            <loader v-if="isSaving" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="cancel"
                v-if="!isSaving"
            >
                Cancel
            </b-button>

            <b-button v-if="!isSaving" variant="primary" @click="proceed">
                Continue
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import Loader from "@/module/commons/loader";

export default {
    components: {
        Loader
    },
    data() {
        return {
            isSaving: false,
            boardingId: null,
            isLoading: false,
            actualNights: 0,
            extendedNights: 0,
            actualCheckoutDateStr: "",
            checkoutData: null,
            type: null,
            creditAmount: 0,
            paymentAmount: 0
        };
    },
    methods: {
        async open({
            actualNights,
            extendedNights,
            actualCheckoutDate,
            checkoutData,
            creditAmount,
            paymentAmount,
            type // INVOICE_PAID_EXTEND | INVOICE_OVERPAID_UNDERPAID
        }) {
            this.type = type;

            if (type === "INVOICE_PAID_EXTEND") {
                this.actualNights = actualNights;
                this.extendedNights = extendedNights;
                this.actualCheckoutDateStr = actualCheckoutDate.format(
                    this.getDateFormat()
                );
            } else if (type === "INVOICE_OVERPAID_UNDERPAID") {
                this.creditAmount = creditAmount;
                this.paymentAmount = paymentAmount;
            }

            this.checkoutData = checkoutData;
            this.$refs.dialog.show();
        },
        proceed() {
            this.$refs.dialog.hide();
            this.$emit("proceed", this.checkoutData);
        },
        cancel() {
            this.$refs.dialog.hide();
            this.$emit("cancel");
        },
        nightLabel(n) {
            if (n === 1) {
                return "1 night";
            } else {
                return n + " nights";
            }
        }
    }
};
</script>
